import { LabeledChipAppearance } from '@components/v2/ui/LabeledChip/labeledChip.styles';
import { isNil } from 'ramda';
import { memo, useMemo } from 'react';
import { CatalogSectionItemClassification } from '../../../modules/catalogs/products/interfaces/catalogProductList.types';
import { ESColorClassification, ESProductTag } from '../../../modules/products/ProductTypes';
import useWidth from '../../Hooks/useWidth';
import TagsWithScroll from '../ScrollableTags/ScrollableTags';
import DynamicTags from './DynamicTags';
import { TagDynamicProps } from './DynamicTags.types';
import { DynamicDifferentsTagsAdapter } from './utils/dynamicDifferentsTags.adapter';

export type DynamicTags = ESColorClassification | ESProductTag | CatalogSectionItemClassification;
interface DynamicTagAdapterProps {
  tags: Array<DynamicTags>;
  variant?: LabeledChipAppearance;
  showTagsWithScrollInMobile?: boolean;
  debounceDelay?: number;
}

const DynamicTagsAdapter = ({
  tags,
  variant,
  showTagsWithScrollInMobile = false,
  debounceDelay,
}: DynamicTagAdapterProps) => {
  const { mobileWidth } = useWidth();

  const adaptedTags = useMemo(
    () =>
      tags.reduce((acc: TagDynamicProps[], tag) => {
        const adaptedTag = new DynamicDifferentsTagsAdapter(tag).toTag();
        if (!isNil(adaptedTag)) {
          acc.push(adaptedTag);
        }

        return acc;
      }, []),
    [tags],
  );

  if (showTagsWithScrollInMobile && mobileWidth) {
    return <TagsWithScroll tags={adaptedTags} variant={variant} />;
  }

  return <DynamicTags tags={adaptedTags} variant={variant} debounceDelay={debounceDelay} />;
};

export default memo(DynamicTagsAdapter);
